import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ErrorService } from 'src/app/error.service';
import { DataStateChangeEventArgs } from '@syncfusion/ej2-angular-grids';
import { GlobalComponent } from 'src/app/global/global.component';
import { GetInbox } from './inbox.model';

@Injectable({
    providedIn: 'root'
})
export class InboxService extends Subject<DataStateChangeEventArgs>{
    constructor(private http: HttpClient, public errorService: ErrorService, public global: GlobalComponent
    ) {
      super()
    }
    public outputValues(state : GetInbox): void{
        this.getEngagementList(state).subscribe(x=>super.next(x));
    }
    getEngagementList(state : GetInbox): Observable<DataStateChangeEventArgs>{
        return this.http.post<any>("api/EngagementLogs/GetInboxList",state)
        .pipe(map(
            (response:any)=>
                <any>{
                    result: response['result'],
                    count: response['count'],
                }
        )).pipe(map((e: any) => {
            e?.result?.forEach((ele) => {
            })
            return e;
          }))
    }
}